// src/components/Profile/CertificationBadge.jsx
import React, { useContext, useRef, useEffect } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import { Award }           from 'lucide-react';
import { TooltipContext }  from './TooltipContext';

const CertificationBadge = () => {
  const { openId, setOpenId } = useContext(TooltipContext);
  const targetRef = useRef(null);
  const timerRef  = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const show = e => {
    e.stopPropagation();            // ← stop the flip
    clearTimeout(timerRef.current);
    setOpenId('cert-badge');
    timerRef.current = setTimeout(() => {
      setOpenId(curr => curr === 'cert-badge' ? null : curr);
    }, 1200);
  };

  const hide = e => {
    e && e.stopPropagation();        // keep it from bubbling
    clearTimeout(timerRef.current);
    setOpenId(curr => curr === 'cert-badge' ? null : curr);
  };

  return (
    <>
      <span
        ref={targetRef}
        className="cert-badge"
        onClick={show}               // handle click/tap
        onTouchStart={show}          // handle mobile tap
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        <Award size={20} className="cert-icon" />
      </span>

      <Overlay
        target={targetRef.current}
        show={openId === 'cert-badge'}
        placement="top"
        transition={false}
        rootClose={true}
        onHide={hide}
      >
        <Tooltip id="tooltip-cert-badge">Board‑Certified CRNA</Tooltip>
      </Overlay>
    </>
  );
};

export default CertificationBadge;
